module.exports = __webpack_public_path__ + "af335e27b72d74bf63a0287cd84f2704.MP3";